import CustomCheckboxCard from './custom-checkbox-card';

export default CustomCheckboxCard;
